import React from 'react';

/**
 * Reusable luxury stat tile for the Creator Dashboard.
 * Maintains the editorial 5-color palette and Cormorant + Outfit type pairing.
 */
const StatsCard = ({ label, value, sub, accent = false, testId }) => (
  <div
    data-testid={testId}
    className={`p-7 border ${
      accent
        ? 'bg-[#7C9CB1] text-[#F4F8F9] border-[#7C9CB1]'
        : 'bg-[#F4F8F9] border-[#C1D7E2] text-[#7C9CB1]'
    }`}
  >
    <p
      className={`font-mono text-[10px] tracking-[0.3em] uppercase mb-4 ${
        accent ? 'text-[#F4F8F9]/80' : 'text-[#90B0BF]'
      }`}
    >
      {label}
    </p>
    <p className="font-serif text-4xl md:text-5xl font-light leading-none">{value}</p>
    {sub && (
      <p
        className={`mt-3 font-mono text-[11px] tracking-[0.2em] ${
          accent ? 'text-[#F4F8F9]/80' : 'text-[#90B0BF]'
        }`}
      >
        {sub}
      </p>
    )}
  </div>
);

export default StatsCard;
